import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import Spinner from "./ui/Spinner";
const baseUrl = process.env.REACT_APP_API_BASE_URL;

const InfoField = ({ label, value }) => (
  <div className="bg-gray-900 rounded-lg p-4">
    <p className="text-sm text-gray-400">{label}</p>
    <p className="mt-1 text-lg font-semibold text-white">{value}</p>
  </div>
);

const UserDetails = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(`${baseUrl}/users/view/${id}`, {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        });

        const result = await response.json();

        if (result?.status === true && result?.data) {
          setUser(result.data);
        } else {
          throw new Error(result?.message || "Failed to fetch user details");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [id]);

  return (
    <div className="flex flex-col md:flex-row bg-gray-900 min-h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Navbar />
        <div className="p-8">
          {loading ? (
            <div className="flex justify-center py-20">
              <Spinner size="lg" />
            </div>
          ) : error ? (
            <p className="text-red-400">Error: {error}</p>
          ) : user ? (
            <>
              <div className="bg-gray-800 p-6 rounded-lg shadow mb-6">
                <div className="flex items-center gap-4">
                  <img
                    src={user.profilePicture}
                    alt="Profile"
                    className="w-20 h-20 rounded-full border border-gray-700 object-cover"
                  />
                  <div>
                    <p className="text-sm text-gray-400">User</p>
                    <h1 className="text-xl font-semibold text-white">{user.username}</h1>
                  </div>
                </div>
              </div>

              <div className="bg-gray-800 p-6 rounded-lg shadow">
                <h2 className="text-xl font-semibold mb-4 text-white">Personal Information</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  <InfoField label="Email Address" value={user.email} />
                  <InfoField label="Coin" value={user.coin || "0"} />
                  <InfoField label="Referral Code" value={user.referralCode || "N/A"} />
                  <InfoField label="Active Mining" value={user.isMiningActive || "0"} />
                  <InfoField label="Mining Speed (ph)" value={user.perHourMiningSpeed || "N/A"} />
                </div>
              </div>
            </>
          ) : (
            <p className="text-gray-400">No user data available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
